export default __webpack_public_path__ + "static/media/brandballoon-two.6c425ce5.png";